@let list = errors();
@if (list.length > 0) {
  <div class="toast-stack" role="region" aria-live="polite" aria-label="Wallet errors">
    @for (err of list; track err.id) {
      <div class="toast">
        <div class="toast-head">
          <span class="toast-icon" aria-hidden="true">!</span>
          <button
            class="toast-x"
            type="button"
            (click)="dismiss(err.id)"
            aria-label="Dismiss"
            title="Dismiss"
          >×</button>
        </div>
        <pre class="toast-body">{{ err.message }}</pre>
        <div class="toast-actions">
          <button
            class="modal-btn modal-btn--block"
            type="button"
            (click)="copy(err)"
            title="Copy debug info"
          >{{ isCopied(err.id) ? 'Copied!' : 'Copy debug info' }}</button>
        </div>
      </div>
    }
  </div>
}
